import React, { useRef, useEffect } from 'react';
import { observer } from 'mobx-react';
import { DownloadButtonVM, IDownloadButtonProps } from './DownloadButtonVM';

const DownloadButtonComponent = (props: IDownloadButtonProps) => {
  const vm = useRef(new DownloadButtonVM(props)).current;
  useEffect(()=>{
    vm.props.disabled = props.disabled;
  },[props.disabled])

  return (
    <button
      className={`usa-button ${vm.props.className ? vm.props.className : ''}`}
      disabled={vm.props.disabled}
      onClick={
        vm.props.createLink
          ? async (e) => {
              vm.props.disabled = true;
              vm.props.href = await props.createLink();
              vm.props.disabled = false;
              vm.downloadHandler(e);
            }
          : vm.downloadHandler
      }
    >
      {props.children}
    </button>
  );
};

export const DownloadButton = observer(DownloadButtonComponent);
